import { render, staticRenderFns } from "./build6.vue?vue&type=template&id=1b6dfbb6&scoped=true&"
import script from "./build6.vue?vue&type=script&lang=js&"
export * from "./build6.vue?vue&type=script&lang=js&"
import style0 from "./build6.vue?vue&type=style&index=0&id=1b6dfbb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6dfbb6",
  null
  
)

export default component.exports